var getUserAgent = function getUserAgent() {
  var _global$navigator, _global$window, _global$window$naviga;
  return ((_global$navigator = global.navigator) === null || _global$navigator === void 0 ? void 0 : _global$navigator.userAgent) || ((_global$window = global.window) === null || _global$window === void 0 ? void 0 : (_global$window$naviga = _global$window.navigator) === null || _global$window$naviga === void 0 ? void 0 : _global$window$naviga.userAgent) || '';
};
export var getIsTouchPlatform = function getIsTouchPlatform() {
  return global.window && 'ontouchstart' in window && (global.navigator && navigator.maxTouchPoints || 0) > 2;
};
export var isTabletUserAgent = function isTabletUserAgent(userAgent) {
  return userAgent === null || userAgent === void 0 ? void 0 : userAgent.toLowerCase().match(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/);
};
export var getIsAndroid = function getIsAndroid(userAgent, browserAppVersion, isTouch, minDimension, maxDimension) {
  var _global$window2;
  if (userAgent.match(/Android/i)) return true;

  // Samsung tablets and other Android devices report as X11 - as they are based on Linux
  //  - The Chrome browser user agent has no other way to identify the platform
  // In this case, we're going to check the dimensions of the screen & touch capability
  //  to make a guess at whether it's a tablet or not.
  var devicePixelRatio = ((_global$window2 = global.window) === null || _global$window2 === void 0 ? void 0 : _global$window2.devicePixelRatio) || 1;
  if (browserAppVersion.indexOf('X11') !== -1 && isTouch && devicePixelRatio > 1 && minDimension < 800 && maxDimension < 1300) return true;
  return false;
};
export var getAppMode = function getAppMode(userAgent, isAndroid, minDimension) {
  if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) return 'mobile';
  if (isAndroid && minDimension < 600) return 'mobile';
  return 'desktop';
};
export var getRegistrationPlatform = function getRegistrationPlatform(userAgent, isTouch, browserAppVersion, minDimension, isAndroid) {
  // These values are used for registration data in Amplitude
  // They should match the ApplicationPlatform type values in the milanote codebase

  if (userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) return 'iPhone web';
  if (userAgent.match(/iPad/i) || browserAppVersion.indexOf('Mac') !== -1 && isTouch) return 'iPad web';
  if (isAndroid) {
    if (isTabletUserAgent(userAgent) || minDimension >= 600) return 'Android tablet web';
    return 'Android phone web';
  }
  return 'Desktop web';
};
export var getPlatformDetails = function getPlatformDetails() {
  var _global$navigator2, _global$window3, _global$window3$scree, _global$window4, _global$window4$scree;
  var userAgent = getUserAgent();
  var isTouch = getIsTouchPlatform();
  var browserAppVersion = (_global$navigator2 = global.navigator) === null || _global$navigator2 === void 0 ? void 0 : _global$navigator2.appVersion;
  var screenWidth = ((_global$window3 = global.window) === null || _global$window3 === void 0 ? void 0 : (_global$window3$scree = _global$window3.screen) === null || _global$window3$scree === void 0 ? void 0 : _global$window3$scree.width) || 2000;
  var screenHeight = ((_global$window4 = global.window) === null || _global$window4 === void 0 ? void 0 : (_global$window4$scree = _global$window4.screen) === null || _global$window4$scree === void 0 ? void 0 : _global$window4$scree.height) || 1000;
  var minDimension = Math.min(screenWidth, screenHeight);
  var maxDimension = Math.max(screenWidth, screenHeight);
  var isAndroid = getIsAndroid(userAgent, browserAppVersion, isTouch, minDimension, maxDimension);
  var platform = getRegistrationPlatform(userAgent, isTouch, browserAppVersion, minDimension, isAndroid);
  var appMode = getAppMode(userAgent, isAndroid, minDimension);
  return {
    platform: platform,
    appMode: appMode
  };
};